const Header = ( {sectionName} ) => {
    return (
        <div className="flex flex-grow fade-element pl-20 pt-20">
            <div style={{ marginLeft: '1px' }}></div>
            <div className="border-b-orange-600 border-b-2 flex-grow">
                <div className="font-inter font-medium flex-grow text-5xl leading-9">
                    {sectionName}
                </div>
                <div style={{ marginBottom: '10px' }}></div>
            </div>
            <div style={{ marginLeft: '5px' }}></div>
        </div>
    );
}

export default Header;